// extracted by mini-css-extract-plugin
module.exports = {"dialog":"ConfirmDialog_dialog__3zNn2","btn":"ConfirmDialog_btn__1uyVj","rotate":"ConfirmDialog_rotate__1Z6K6"};